import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

import user from "./user";
import feedback from "./feedback";
import log from "./log";
import salesTeam from "./salesTeam";
import unmatchedEmails from "./unmatched-emails";
import vehicle from "./vehicle";
import warehouse from "./warehouse";
import warehouseMap from "./warehouseMap";

const children = [
  ...feedback.routes,
  ...log.routes,
  ...salesTeam.routes,
  ...user.routes,
  ...unmatchedEmails.routes,
  ...vehicle.routes,
  ...warehouse.routes,
  ...warehouseMap.routes,
];

export default {
  routes: [
    {
      name: "admin",
      path: "admin",
      component: () => import("pages/admin/Index"),
      meta: {
        auth: () =>
          children.some((route) => route.meta.auth && route.meta.auth()),
        icon: "admin",
        title: i18n.global.t("Administration"),
        color: "admin",
      },
      children,
    },
  ],

  dialogs: [
    ...feedback.dialogs,
    ...log.dialogs,
    ...salesTeam.dialogs,
    ...user.dialogs,
    ...unmatchedEmails.dialogs,
    ...vehicle.dialogs,
    ...warehouseMap.dialogs,
  ],
};
